import React from 'react';
import { CHAT_API_URL, EVENT_ID, INNON_WEBSOCKET_URL } from '../../constants';
import ChatItem from '../../components/chat/ChatItem';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { Grid, withStyles } from '@material-ui/core';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import MainContext from '../../MainContext';
// import { CustomSwal } from '../../components/CustomSwal';
import swal from '@sweetalert/with-react';

const chatStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  tabPanel: {
    flexGrow: 1,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      marginBottom: 0,
      backgroundColor: '#ffffff',
    },
  },
  chatPanel: {
    width: '100%',
    height: 'calc(100vh - 395px)',
    overflowY: 'scroll',
    backgroundColor: '#f4f4f4',
    marginBottom: '15px',
    padding: '10px 5px',
    borderBottom: '1px solid #e7e7e7',
    [theme.breakpoints.down('lg')]: {
      height: 'calc(100vh - 416px)',
    },
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'none',
      height: '20vh',
    },
  },
  chatInput: {
    width: '65%',
    backgroundColor: '#fafafa',
    borderColor: '#e2e2e2',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  chatSend: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      //position: 'fixed',
      bottom: 82,
      left: 0,
      padding: '5px',
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e7e7e7',
      zIndex: 999,
    },
  },
  chatSpace: {
    width: '5%',
    [theme.breakpoints.down('sm')]: {
      width: 0,
    },
  },
  chatText: {
    width: '100%',
    color: 'rgba(59, 59, 59, 0.6)',
    fontSize: '0.85em',
    paddingLeft: '5.5%',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#ffffff',
      position: 'fixed',
      bottom: '6.5%',
      paddingLeft: '2%',
    },
  },
});

class Chat extends React.Component {
  static contextType = MainContext;
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      msg: '',
      channelId: props.channel,
      openAttendPopup: true,
      dumy: [],
      username: sessionStorage.getItem('_in_name'),
      listTimer: null,
    };
    this.addMessage = this.addMessage.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.handleInput = this.handleInput.bind(this);
    //this.getChatList = this.getChatList.bind(this);
  }

  syncChat = () => {
    if (this.state.listTimer !== null) {
      clearInterval(this.state.listTimer);
      this.setState({ listTimer: null });
    }
    this.getChatList(false);
    let buff = setInterval(() => {
      this.getChatList(true);
    }, 1000);
    this.setState({ listTimer: buff });
  };

  clearChatList = () => {
    this.setState({ dumy: [] });
    //this.getChatList(false);
  };

  getChatList = (bChat) => {
    if (this.props.session === '') {
      // if (this.context) console.log(this.context.arrCurrentSesseion);
    }

    if (this.props.session !== '' && bChat) {
      if (this.state.listTimer !== null) {
        clearInterval(this.state.listTimer);
        this.setState({ listTimer: null });
      }
    }
    /*
    let session = sessionStorage.getItem('_in_session');

    if (!session) {
      alert('세션정보가 없습니다.');
      return;
    }
    */
    if (this.props.session !== '') {
      axios
        .get(`${CHAT_API_URL}/chat/list?eventId=${EVENT_ID}&session=${this.props.session}`, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          let buff = [];
          for (let i = 0; i < response.data.Items.length; i++) {
            buff.push(response.data.Items[i].msg);
          }

          buff.sort(function (a, b) {
            // IE list sort fix
            // return a.createAt > b.createAt ? 1 : -1;
            return Number(a.createdAt) > Number(b.createdAt) ? 1 : -1;
          });

          // console.log(buff);
          this.setState({ dumy: buff });

          setTimeout(() => {
            let chatPanel = document.getElementById('chatPanel');
            if (chatPanel) chatPanel.scrollTop = chatPanel.scrollHeight;
          }, 500);
        });
    }
  };

  componentDidMount() {
    const evtTarget = document.getElementById('outlined-adornment-weight');
    evtTarget.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    });

    //this.setState({ chatSocket: new WebSocket(INNON_WEBSOCKET_URL) });
    //this.state.chatSocket = new WebSocket(WEBSOCKET_URL);
    setTimeout(() => {
      let chatPanel = document.getElementById('chatPanel');
      if (chatPanel) chatPanel.scrollTop = chatPanel.scrollHeight;
      this.socketManager();
    }, 500);

    this.syncChat();
    //this.getChatList();
  }

  componentWillUnmount() {
    const evtTarget = document.getElementById('outlined-adornment-weight');
    evtTarget.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    });
  }

  socketManager() {
    console.log('>>> socketManger <<<');

    let socket = new WebSocket(INNON_WEBSOCKET_URL);
    this.setState({ mainSocket: socket });
    if (!sessionStorage.getItem('_in_user_')) {
      if (this.props.history) this.props.history.push('/');
      else window.location.href = '/';
    }

    socket.onopen = (event) => {
      console.log('onopen chat socket', this.state.channelId);
      socket.send(JSON.stringify({ action: 'sendmessage', type: 'join', room: this.state.channelId, evt: EVENT_ID }));
    };
    socket.onmessage = (event) => {
      console.log('onMessage');
      console.log(event);
      this.addMessage(event);
    };
    socket.onclose = (event) => {
      console.log('onclose', sessionStorage.getItem('_in_user_'));
      if (sessionStorage.getItem('_in_user_')) {
        this.socketManager();
      }
    };
    socket.onerror = (event) => {
      console.log('onerror', event);
    };
  }
  addMessage = (event) => {
    let old = this.state.dumy;

    if (this.context) console.log(this.context.arrCurrentSesseion);
    //old.push({ username: this.state.username, msg: event.data, userId: sessionStorage.getItem('_in_user_') });

    let data = JSON.parse(event.data);

    old.push(data);

    this.setState({ dumy: old });

    setTimeout(() => {
      let chatPanel = document.getElementById('chatPanel');
      chatPanel.scrollTop = chatPanel.scrollHeight;
    }, 100);
  };

  sendMessage() {
    console.log('sendMessage');
    console.log(this.state.msg);

    let session = sessionStorage.getItem('_in_session');

    console.log('session info');
    console.log(session);

    if (!session) {
      // alert('세션정보가 없습니다.');
      // CustomSwal('', 'This is not session time.', '');
      swal('', 'This is not session time.', '');
      return;
    }

    if (this.state.msg === '') {
      // alert('메시지를 입력바랍니다.');
      // CustomSwal('', 'Please enter your message.', '');
      swal('', 'Please enter your message.', '');
      return;
    }

    console.log(this.state.channelId);
    console.log(
      JSON.stringify({
        action: 'sendmessage',
        type: 'msg',
        data: this.state.msg,
        room: this.state.channelId,
        evt: EVENT_ID,
        session: session,
        username: sessionStorage.getItem('_in_name'),
        usernameEn: sessionStorage.getItem('_in_name_en'),
        userid: sessionStorage.getItem('_in_user_'),
        style: '',
      }),
    );

    if (
      !sessionStorage.getItem('_in_name_en') ||
      sessionStorage.getItem('_in_name_en') === '' ||
      sessionStorage.getItem('_in_name_en') === 'undefined'
    ) {
      this.state.mainSocket.send(
        JSON.stringify({
          action: 'sendmessage',
          type: 'msg',
          data: this.state.msg,
          room: this.state.channelId,
          evt: EVENT_ID,
          session: session,
          username: sessionStorage.getItem('_in_name'),
          userid: sessionStorage.getItem('_in_user_'),
          style: '',
        }),
      );
    } else {
      this.state.mainSocket.send(
        JSON.stringify({
          action: 'sendmessage',
          type: 'msg',
          data: this.state.msg,
          room: this.state.channelId,
          evt: EVENT_ID,
          session: session,
          username: sessionStorage.getItem('_in_name'),
          usernameEn: sessionStorage.getItem('_in_name_en'),
          userid: sessionStorage.getItem('_in_user_'),
          style: '',
        }),
      );
    }

    this.setState({ msg: '' });
  }

  handleInput(event) {
    //console.log(event.target.value);
    this.setState({ msg: event.target.value });
  }

  render() {
    const { classes } = this.props;
    //const { msg } = this.state;
    return (
      <Grid container spacing={0} direction={'row'} justifyContent={'space-between'} alignItems={'flex-end'} className={classes.tabPanel}>
        <div className={classes.chatPanel} id={'chatPanel'}>
          {this.state.dumy.map((item, idx) => {
            return <ChatItem chatData={item} key={idx} />;
          })}
        </div>
        <div className={classes.chatSend} style={{ display: 'flex' }}>
          <div className={classes.chatSpace} />
          <FormControl variant="outlined" className={classes.chatInput}>
            <OutlinedInput
              id="outlined-adornment-weight"
              value={this.state.msg}
              onChange={this.handleInput}
              placeholder="Type your message."
              fullWidth
              multiline
              rows={2}
              /*
              endAdornment={
                <InputAdornment position="end">
                  <IconButton aria-label={'send button'} onClick={this.sendMessage}>
                    <SendIcon />
                  </IconButton>
                </InputAdornment>
              }
              */
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                'aria-label': 'weight',
              }}
              labelWidth={0}
            />
          </FormControl>
          <div style={{ width: '5%' }} />
          <Button
            onClick={this.sendMessage}
            variant="contained"
            color="primary"
            style={{ width: '20%', color: '#ffffff', textTransform: 'none' }}
          >
            Submit
          </Button>
        </div>
      </Grid>
    );
  }
}
export default withStyles(chatStyles, { withTheme: true })(Chat);
